import { render, staticRenderFns } from "./JimProfile.vue?vue&type=template&id=2a325432"
import script from "./JimProfile.vue?vue&type=script&lang=js"
export * from "./JimProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/JimProfile.vue
// module id = null
// module chunks = 